import React from 'react';

const Language = () => {
    return(
        <div className="Language">
            <h1 onClick={(e) => {e.preventDefault(); window.location.href='https://translate.google.com/translate?sl=ja&tl=en&u=https://chatbot-demo-dc9da.web.app';}}>English</h1>
        </div>
    )
}

export default Language;